module.exports = __webpack_public_path__ + "img/business2.76a98d30.png";